import { useEffect } from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

interface AnalyticsProps {
  gaId?: string;
}

export function Analytics({ gaId = 'G-XXXXXXXXXX' }: AnalyticsProps) {
  const { analytics } = useCookieConsent();

  useEffect(() => {
    // Only load GA4 if user has given consent and we have a valid ID
    if (!analytics || gaId === 'G-XXXXXXXXXX') return;

    // Check if already loaded
    if (document.getElementById('ga-script')) return;

    // Load Google Analytics 4
    const script = document.createElement('script');
    script.id = 'ga-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer ?? [];
    const dataLayer = window.dataLayer;
    function gtag(...args: unknown[]) {
      dataLayer.push(args);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', gaId, {
      'anonymize_ip': true,
      'cookie_flags': 'SameSite=None;Secure'
    });

  }, [analytics, gaId]);

  return null;
}
